import React from 'react';
import './loader.css';

export default () => (
  <div>
    <div class="loader"></div>
  </div>
);
